import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormBuilderOutlineSection,
  BackendMutationDeleteLongFormBuilderOutlineSectionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteLongFormBuilderOutlineSection($id: ID!) {
    deleteLongFormBuilderOutlineSection(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteLongFormBuilderOutlineSectionArgs;
type Result = Pick<BackendLongFormBuilderOutlineSection, 'id'>;

export const deleteLongFormBuilderOutlineSection = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
